import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';

import * as actions from '../../../actions';
import * as c from '../../../constant';

function UpdateRemarksModal({
  createTextArea,
  endorsingOfficeRemarks,
  formData,
  setFormData,
  data,
  updating,
  getItem,
  getEndorsingOfficesList,
  id,
  handleEndorsingOffice,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      remarks: formData.remarks,
      other_fee_id: _.get(data, 'other_fee_id'),
      endorsing_office_id: _.get(data, 'endorsing_office.id'),
    };

    endorsingOfficeRemarks(id, args, () => {
      setModal({ isOpen: false });
      getItem(id);
      getEndorsingOfficesList(id);
      handleEndorsingOffice(e);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    handleEndorsingOffice(e);
  };

  const onSetFormData = () => {
    if (!_.isEmpty(data)) {
      const args = {
        ...data,
      };

      setFormData(_.pick(args, _.keys(c.FORM_DATA_REMARKS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createTextArea(
              { key: 'remarks', label: `Remarks` },
              { rows: '15' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Update`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateRemarksModal.propTypes = {
  createTextArea: PropTypes.instanceOf(Function).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  endorsingOfficeRemarks: PropTypes.instanceOf(Function).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  getEndorsingOfficesList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  handleEndorsingOffice: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.ENDORSING_OFFICE_REMARKS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateRemarksModal);
